
  /** 查询地图排线列表*/
  export const API_SUB_ROUTE_ITEM_QUERTMAPROUTESEARCHLIST = {
    url: 'api/tms/route/item/mapRouteSearchListRpc',
    config: {
      method: 'POST',
      host: 'SUPPLIER',
    },
  };
   /** 每日排线 - 获取当前仓库下所有路线*/
   export const API_ROUTE_MAPROUTESELECTALLLIST = {
    url: 'api/tms/route/item/mapRouteSelectAllListRpc',
    config: {
      method: 'POST',
      host: 'SUPPLIER',
    },
  };
  
 /** 排线- 地图查询客户来源*/
export const API_ROUTE_ITEM_SELECTORDERBUSINESSTYPEENUM = {
  url: 'api/tms/route/item/selectOrderBusinessTypeEnumRpc',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};

  /** 排线- 地图查询客户列表*/
  export const API_ROUTE_ITEM_CUSTOMERBYLONGITUDE = {
    url: 'api/tms/route/item/customerByLongitudeRpc',
    config: {
      method: 'POST',
      host: 'SUPPLIER',
    },
  };
  /** 排线 - 查询小类枚举 */
export const API_ROUTE_GETTMSCUSTOMERSMALLLEVELLIST = {
  url: 'api/tms/route/item/getTmsCustomerSmallLevelList',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};